export default __webpack_public_path__ + "static/media/AdobeStock_97914201.7988a3e7.jpg";